import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { VerticalLanding } from './pages/VerticalLanding';
// Dashboard is now accessed through AppShell (/app) — /dashboard redirects there
import { Upload } from './pages/Upload';
import { Results } from './pages/Results';
import { Purchase } from './pages/Purchase';
import { Account } from './pages/Account';
import { Compare } from './pages/Compare';
import { Shootout } from './pages/Shootout';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Pricing } from './pages/Pricing';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Challenge } from './pages/Challenge';
import { GuessChallenge } from './pages/GuessChallenge';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { NotFound } from './pages/NotFound';
import { HingeGuide } from './pages/guides/HingeGuide';
import { TinderGuide } from './pages/guides/TinderGuide';
import { BumbleGuide } from './pages/guides/BumbleGuide';
import { LinkedInGuide } from './pages/guides/LinkedInGuide';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastContainer } from './components/Toast';
import { AppShell } from './components/AppShell';
import { usePageView } from './hooks/usePageView';

function PageViewTracker() {
  usePageView();
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <ToastContainer />
      <AuthProvider>
        <PageViewTracker />
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dating" element={<VerticalLanding vertical="dating" />} />
            <Route path="/linkedin" element={<VerticalLanding vertical="linkedin" />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/challenge/:challengeId" element={<Challenge />} />
            <Route path="/guess/:id" element={<GuessChallenge />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/guides/hinge" element={<HingeGuide />} />
            <Route path="/guides/tinder" element={<TinderGuide />} />
            <Route path="/guides/bumble" element={<BumbleGuide />} />
            <Route path="/guides/linkedin" element={<LinkedInGuide />} />
            <Route path="/dashboard" element={<Navigate to="/app" replace />} />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <Upload />
                </ProtectedRoute>
              }
            />
            <Route
              path="/results/:photoId"
              element={
                <ProtectedRoute>
                  <Results />
                </ProtectedRoute>
              }
            />
            <Route
              path="/purchase"
              element={
                <ProtectedRoute>
                  <Purchase />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shootout"
              element={
                <ProtectedRoute>
                  <Shootout />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compare"
              element={
                <ProtectedRoute>
                  <Compare />
                </ProtectedRoute>
              }
            />
            <Route path="/compare-details" element={<Navigate to="/compare" replace />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
